import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const upsert = (selector, create, apply) => {
  let el = document.head.querySelector(selector);
  if (!el) { el = create(); document.head.appendChild(el); }
  apply(el);
};

const setMeta = (key, keyVal, value) =>
  upsert(`meta[${key}="${keyVal}"]`, () => {
    const m = document.createElement("meta");
    m.setAttribute(key, keyVal);
    return m;
  }, (m) => m.setAttribute("content", value));

const setCanonical = (href) =>
  upsert('link[rel="canonical"]', () => {
    const l = document.createElement("link");
    l.setAttribute("rel", "canonical");
    return l;
  }, (l) => l.setAttribute("href", href));

// Keeps <title>, meta description, og tags and canonical in sync with route + language.
export const SeoManager = () => {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    const map = {
      "/": ["seo.homeTitle", "seo.homeDesc"],
      "/jobs": ["seo.jobsTitle", "seo.jobsDesc"],
      "/login": ["seo.loginTitle", "seo.loginDesc"],
      "/register": ["seo.registerTitle", "seo.registerDesc"],
      "/help": ["seo.helpTitle", "seo.helpDesc"],
    };
    const [titleKey, descKey] = map[pathname] || ["seo.defaultTitle", "seo.defaultDesc"];
    const title = t(titleKey);
    const desc = t(descKey);
    const url = window.location.origin + pathname;

    document.title = title;
    document.documentElement.lang = i18n.language?.startsWith("en") ? "en" : "es";
    setMeta("name", "description", desc);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setCanonical(url);
  }, [pathname, i18n.language, t]);

  return null;
};
